import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

// Live sellers list. Only active sellers with a store_name. Ranked by rating
// then product_count so the slideshow features strong shops first.
//
// Cached via TanStack Query — staleTime 5 min so tab revisits render
// instantly while a quiet background refetch keeps it fresh.
export function useStores({ limit = 20 } = {}) {
  const { data, isLoading } = useQuery({
    queryKey: ["stores", { limit }],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("sellers")
        .select(
          "id, user_id, store_name, store_slug, description, category, logo_url, cover_url, rating_avg, rating_count, product_count, delivery_fee, delivery_options, total_orders, address, latitude, longitude, status"
        )
        .eq("status", "active")
        .not("store_name", "is", null)
        .order("rating_avg", { ascending: false, nullsFirst: false })
        .order("product_count", { ascending: false })
        .limit(limit);
      if (error) throw error;
      return data || [];
    },
    staleTime: 5 * 60_000,
  });

  return { stores: data || [], loading: isLoading };
}
